// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"108":"ed860dbf","156":"dc7f0166","182":"2115a2e6","228":"06dfa768","366":"ba2c8b5c","536":"6aa9603a","582":"467e468d","616":"3e437d44","712":"eb71dfbd","766":"764b4b3d","838":"9c91b826"}[chunkId] + ".chunk.js";
};